import React, { useState } from 'react';
import Grid from "@mui/material/Grid";
import Box from '@mui/material/Box';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import moment from 'moment';

export const ConexionesDetalleHeader = ({
    hc = '-',
    paciente = '-',
    documento = '-',
    fechaDesdeHasta = '-',
    contrato = '-',
    getChipEstado,
    planDescripcion = '-',
    contratoFechaDesde = '',
    contratoFechaHasta = ''
}) => {
    const estados = [
        { key: 'ap', description: 'Apto para Adición de conexión' },
        { key: 'PE', description: 'Pendiente' },
        { key: 'AT', description: 'Autorizada' },
        { key: 'SU', description: 'Suspendido' },
        { key: 'PF', description: 'Pendiente de facturar' },
        { key: 'FF', description: 'Facturada' },
        { key: 'BC', description: 'Borradas' },
        { key: 'NC', description: 'No Corresponde' },
        { key: '-', description: 'Sin Información' },
    ]

    const [openModal, setOpenModal] = useState(false);

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    return (
        <>
            <Grid
                container
                justifyContent={'space-between'}
                alignItems={'center'}
                marginBottom={'20px'}
                rowSpacing={2}
            >
 <Grid size={{ xs: 12 }}>
                    <Box sx={{
                        background: '#E0E1E3',
                        padding: '10px 15px',
                        borderRadius: '10px',
                        fontSize: 12
                    }}>
                        <Box sx={{ mb: 0.5, fontSize: 13 }}>
                            <strong >Detalles de conexiones</strong>
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-evenly',
                            flexWrap: 'wrap',
                            gap: '10px'
                        }}>
                            <Box sx={{ flex: '1 0 30%' }}>
                                <span><strong>Nro. HC:</strong> {hc}</span>
                            </Box>
                            <Box sx={{ flex: '1 0 30%' }}>
                                <span><strong>Paciente:</strong> {paciente}</span>
                            </Box>
                            <Box sx={{ flex: '1 0 30%' }}>
                                <span><strong>Documento:</strong> {documento}</span>
                            </Box>
                            <Box sx={{ flex: '1 0 30%' }}>
                                <span><strong>Plan:</strong> {planDescripcion}</span>
                            </Box>
                            <Box sx={{ flex: '1 0 30%' }}>
                                <span><strong>Nro. Contrato:</strong> {contrato}</span>
                            </Box>
                            <Box sx={{ flex: '1 0 30%' }}>
                                <span><strong>F. Desde y hasta:</strong> {`${moment(contratoFechaDesde).format('DD/MM/YYYY')} - ${moment(contratoFechaHasta).format('DD/MM/YYYY')}`}</span>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
 <Grid size={{ xs: 12 }}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        color: '#2D72B4'
                    }}>
                        <CustomButton
                            variant='none'
                            onClick={handleOpenModal}
                        >
                            <InfoOutlinedIcon sx={{ mr: 1 }} />
                            <Box sx={{ textTransform: 'none', fontSize: 12 }}>
                                <strong>
                                    Ver referencias de tipo de estado
                                </strong>
                            </Box>
                        </CustomButton>
                    </Box>
                </Grid>
            </Grid>
            <CustomDialog
                maxWidth="sm"
                fullWidth={true}
                open={openModal}
                title='Referencias de tipos de estado'
                onCancel={handleCloseModal}
                cancelText='Cerrar'
            >
                {estados.map(estado => {
                    return <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Box sx={{ mr: 1 }}>{getChipEstado(estado.key)}</Box>
                        {estado.description}
                    </Box>
                })}
            </CustomDialog>
        </>
    );
}